import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import BusinessMandatePage from './BusinessMandatePage';
import { dataCaptureSelectors, saveBusinessMandatePage } from '../../store/dataCapture';
import { MANDATE_INFO, ROUTE_SIGNIFICANT_PEOPLE_PAGE } from '../../utils/constants';

class BusinessMandateSection extends Component {
  constructor(props) {
    super(props);
    this.businessBack = this.businessBack.bind(this);
  }

  businessBack() {
    // @TODOxCYBG: Back to Review People page
    this.props.history.push(ROUTE_SIGNIFICANT_PEOPLE_PAGE);
  }

  render() {
    const { bankId, brandId, saveBusinessMandatePage, getBusinessData } = this.props;

    return (
      <BusinessMandatePage
        brandId={brandId}
        bankId={bankId}
        saveBusinessMandatePage={saveBusinessMandatePage}
        getBusinessData={getBusinessData}
        backClick={this.businessBack}
      />
    );
  }
}

BusinessMandateSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveBusinessMandatePage: PropTypes.func.isRequired
};

const actionCreators = {
  saveBusinessMandatePage
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  getBusinessData: dataCaptureSelectors.getBusinessData(state, MANDATE_INFO)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BusinessMandateSection);
